import { render, staticRenderFns } from "./communityActivity.vue?vue&type=template&id=5be6c919&scoped=true"
import script from "./communityActivity.vue?vue&type=script&lang=js"
export * from "./communityActivity.vue?vue&type=script&lang=js"
import style0 from "./communityActivity.vue?vue&type=style&index=0&id=5be6c919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be6c919",
  null
  
)

export default component.exports